import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Necesito mucho dinero para empezar?',
    a: 'No, con $20 USD de ingredientes básicos puedes arrancar tu primer ciclo.'
  }, {
    q: '¿Tengo que manejar?',
    a: 'No, el manual te enseña a que los clientes recojan en tu puerta o tú entregues a pie en tu radio.'
  }, {
    q: '¿Cuánto tiempo toma preparar los pedidos?',
    a: 'Con los platos sugeridos del menú Best-Seller, puedes preparar 10 platos en 2-3 horas por la mañana y entregar a mediodía.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-kitchen-white py-12 md:py-24 px-5 md:px-12 lg:px-24" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <FadeIn data-id="element-16">
          <h2 className="font-lora text-2xl md:text-4xl font-bold text-kitchen-brown text-center mb-8 md:mb-12" data-id="element-17">
            Preguntas Frecuentes ❓
          </h2>
        </FadeIn>

        <div className="space-y-3 md:space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-19">
              <div className={`border-2 rounded-2xl overflow-hidden transition-colors ${openIndex === index ? 'border-kitchen-amber bg-kitchen-cream' : 'border-kitchen-brown/10 bg-white'}`} data-id="element-20">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-21">
                  <span className="font-lora text-xl font-bold text-kitchen-brown pr-4" data-id="element-22">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-6 h-6 text-kitchen-terracotta flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-23" />
                </button>
                <AnimatePresence data-id="element-24">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-25">
                      <div className="px-6 pb-5 font-nunito text-lg text-kitchen-brown/80" data-id="element-26">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}